import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export const applyLeave = async (leave: { leave_date: string; duration: number; remarks?: string }) => {
  const { data } = await axios.post(
    `${API_URL}/api/v1/leave/apply`,
    leave,
    {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    }
  );
  return data;
};

export const getLeaveBalance = async () => {
  const { data } = await axios.get(
    `${API_URL}/api/v1/leave/balance`,
    {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    }
  );
  return data;
};

export const getMyLeaves = async () => {
  const { data } = await axios.get(
    `${API_URL}/api/v1/leave/my-leaves`,
    {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    }
  );
  return data;
};

export const getAllLeaveBalances = async () => {
  const { data } = await axios.get(
    `${API_URL}/api/v1/leave/all-balances`,
    {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    }
  );
  return data;
};

export const getAllLeaves = async () => {
  const { data } = await axios.get(
    `${API_URL}/api/v1/leave/all-leaves`,
    {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    }
  );
  return data;
};

export const editLeave = async (leave_id: number, leave: { leave_date: string; duration: number; remarks?: string }) => {
  const { data } = await axios.put(
    `${API_URL}/api/v1/leave/edit/${leave_id}`,
    leave,
    {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    }
  );
  return data;
};
